const CARD = {
  R:   18,   // border-radius
  GAP: 16,   // gap between L-card notch and map card
};

let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

function buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`,
    ].join(' ');
}
function getCardConfig(W) {
    if (W < 640) {
        return {
            R: 10,
            GAP: 0,
            mapWidthRatio: 0.95,
            mapHeightRatio: 1,
            notch: false,   // ← plain rounded rect, no map cutout
        };
    }
    if (W < 900) {
        return { R: 18, GAP: 16, mapWidthRatio: 0.5, mapHeightRatio: 0.5, notch: true };
    }
    return {
        R: 18, 
        GAP: 16, 
        mapWidthRatio: 0.5, 
        mapHeightRatio: 0.5, 
        notch: true };
}
function buildPath(W, H, CARD) {
    const cfg = getCardConfig(W);
    const MAP_W    = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H = Math.min(W * cfg.mapHeightRatio * 34 / 45 - cfg.GAP, H - cfg.GAP * 2);
    const MAP_LEFT = W - MAP_W;

    if (!cfg.notch) {
        // Mobile: simple rounded rect, no notch geometry needed
        return { d: buildRectPath(W, H, cfg.R), MAP_W, MAP_H, MAP_LEFT };
    }

    const NOTCH_X = MAP_LEFT - cfg.GAP;
    const NOTCH_Y = MAP_H + cfg.GAP;

    const d = [
        `M ${cfg.R} 0`,
        `L ${NOTCH_X - cfg.R} 0`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${NOTCH_X} ${cfg.R}`,
        `L ${NOTCH_X} ${NOTCH_Y - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 0 ${NOTCH_X + cfg.R} ${NOTCH_Y}`,
        `L ${W - cfg.R} ${NOTCH_Y}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W} ${NOTCH_Y + cfg.R}`,
        `L ${W} ${H - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W - cfg.R} ${H}`,
        `L ${cfg.R} ${H}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 0 ${H - cfg.R}`,
        `L 0 ${cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${cfg.R} 0 Z`,
    ].join(' ');

    return { d, MAP_W, MAP_H, MAP_LEFT };
}

    const appdDemo = document.querySelector('.app-demo');
    const containerHeader = document.getElementById('s-header-container');
    const cardContent = document.querySelector('.tracker-peack');
    const cardRoot = document.querySelector('.mln-card-root');
    const viewbox = document.querySelector('.viewbox');

    let prevIsMobile = null;

function reparentMapCard(isMobile) {
    if (isMobile === prevIsMobile) return;
    prevIsMobile = isMobile;

    if (isMobile) {
        appdDemo.style.position = 'static';
        appdDemo.style.alignSelf = 'center';
        appdDemo.style.background = "none";
        appdDemo.style.boxShadow = "none";
        cardContent.style.width = '100%';
        cardContent.insertBefore(appdDemo, cardContent.children[1]);

    } else {
        cardRoot.appendChild(appdDemo);
        appdDemo.style.position = 'absolute';
        appdDemo.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        appdDemo.style.boxShadow = "-8px -8px 20px var(--shadow-light), 8px 8px 20px var(--shadow-dark), inset -5px -5px 15px var(--shadow-light), inset 5px 5px 10px #aeaec040";
        cardContent.style.width = "calc(50% - 32px)";
    }
}

    function applyGeometry(W, H) {
        const { d, MAP_W, MAP_H, MAP_LEFT } = buildPath(W, H, CARD);

        // L-card clip
        const mlnCard = document.getElementById('mlnCard');
        // if (mlnCard) mlnCard.style.clipPath = `path("${d}")`;

        // Single SVG path — convex-bubble filter only
        const shadowPath = document.getElementById('insetLightPath');
        if (shadowPath) shadowPath.setAttribute('d', d);

        // SVG canvas sizing
        const svg = document.getElementById('mlnf-inset-svg');
        if (svg) {
            svg.setAttribute('width',  W);
            svg.setAttribute('height', H);
        }

        // Map card position + size
        const map = document.querySelector('.app-demo');
        if (map) {
            map.style.left   = `${MAP_LEFT}px`;
            map.style.width  = `${MAP_W}px`;
            map.style.height = `${MAP_H}px`;
        }
        if (cardContent) {
            const headerH = containerHeader ? containerHeader.getBoundingClientRect().height : 0;
            cardContent.style.minHeight = `${Math.max(0, MAP_H - headerH)}px`;
        }
    }
const ro = new ResizeObserver(entries => {
    const { width, height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    reparentMapCard(isMobile);
    applyGeometry(width, height); // always runs now
});

ro.observe(cardRoot);